<template>
  <main class="form-signin">
    <form>
      <img class="mb-4" src="../assets/logo.png" alt="Logo" width="200" height="110" /><br />
      <strong>PASSWORD RESET</strong>
      <p>Please, write down your new password</p>
      <div class="form-floating">
        <input type="password" class="form-control" id="newPassword" placeholder="password" v-model="user.password" />
        <label for="newPassword">New Password</label>
      </div>

      <div class="form-floating">
        <input
          type="password"
          class="form-control"
          id="confirmPassword"
          placeholder="Repeat password"
          v-model="user.confirmPassword"
        />
        <label for="confirmPassword">Confirm Password</label>
      </div>
      <button class="w-100 btn btn-lg btn-primary" type="button" @click="saveNewPassword">Save</button>
      <p>Try login to your mobile application after changing your password</p>
      <p class="mt-5 mb-3 text-muted">&copy; GOFAR</p>
    </form>
  </main>
</template>

<script>
import { apiClient } from '../helpers/api-client';
import { HTTP_STATUS_CODES } from '../helpers/config';

export default {
  name: 'ForgotPassword',
  data() {
    return {
      user: {
        password: '',
        confirmPassword: ''
      }
    };
  },
  methods: {
    async saveNewPassword() {
      if (this.user.password !== this.user.confirmPassword) {
        this.$notify({
          title: 'Fail!',
          text: "Password and confirm password do not match!",
          type: 'warn',
          duration: 30000 // keep it forever visible unless clicked
        });
        return;
      }
      try {
        const res = await apiClient(`/users/reset-password?access_token=${this.$route.query.access_token}`, 'POST', {
          password: this.user.password,
          confirmation: this.user.confirmPassword
        }, {redirectOnUnauthorized: false});
        if (res.status === HTTP_STATUS_CODES.NO_CONTENT) {
          this.$notify({
            title: 'Success!',
            text: 'Password has been changed!',
            type: 'success',
            duration: 60000
          });
        }
      } catch (err) {
        this.$notify({
          title: 'Fail!',
          text: "Password couldn't be changed!",
          type: 'error',
          duration: 30000
        });
      }
    }
  }
};
</script>

<style scoped>
.form-signin {
  max-width: 330px;
  padding: 15px;
  margin: auto;
  text-align: center;
  font-size: 14px;
}

.form-signin input[type='email'] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.form-signin input[type='password'] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>
